import React from "react";
import { CompositeAssetsTable } from "./comparablesSummary/CompositeAssetsTable";
import { Divider } from "common/components/listItems/Divider";
import { CompositeAsset } from "../types/api.types";
import { ConservativeValue } from "common/types/common.types";
import { ConservativeValueInfo } from "./comparablesSummary/ConservativeValueInfo";
import { useTranslation } from "react-i18next";

interface PredictionCompositeAssetsProps {
  propertyId: string;
  pricePredictionId?: string;
  compositeAssets?: CompositeAsset[];
  conservativeValue?: ConservativeValue;
}

export const PredictionCompositeAssets: React.FC<
  PredictionCompositeAssetsProps
> = ({ propertyId, pricePredictionId, compositeAssets, conservativeValue }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div>{t("predictionCompositeAssets.assetUnits")}</div>
      <Divider
        style={{
          marginVertical: "10px",
        }}
      />
      <CompositeAssetsTable
        propertyId={propertyId}
        pricePredicitionId={pricePredictionId}
        readonly
        compositeAssets={compositeAssets}
        conservativeValue={conservativeValue}
      />
      {!!conservativeValue && (
        <ConservativeValueInfo conservativeValue={conservativeValue} />
      )}
    </div>
  );
};
